

// Multi File Upload
// reveal hidden file uploads with button.
ready(function() {
    const multiFileUploads = findAll('.multi-file-upload');


    multiFileUploads.forEach((multiFileUpload) => {

        const inputFiles = multiFileUpload.findAll('.input-file');
        const addFileButton = multiFileUpload.find('.button');

        // Store original label content for each input
        const originalLabels = new Map();

        // successively add "active" class. hide button if all are visible
        inputFiles.forEach((inputFile, index) => {
            if (index === 0) {
                inputFile.classList.add('active');
            } else {
                inputFile.classList.remove('active');
            }

            // Add change event listener to each file input
            const fileInput = inputFile.find('input[type="file"]');
            const label = inputFile.find('label');
            const labelContent = label.find('.label-content');
            const originalLabelContent = labelContent ? labelContent.innerHTML : label.innerHTML; // Store original label content

            // Store original content in map
            originalLabels.set(inputFile, originalLabelContent);

            // Function to update file display
            function updateFileDisplay() {
                if (fileInput.files && fileInput.files.length > 0) {
                    inputFile.classList.add('has-file');
                    // Display filename - only update the label content, not the entire label
                    const fileName = fileInput.files[0].name;
                    if (labelContent) {
                        labelContent.innerHTML = `<span class="filename">${fileName}</span><div class="remove-file" role="button" aria-label="Datei entfernen"></div>`;
                    } else {
                        // Fallback if no .label-content wrapper exists
                        const fileInputElement = label.find('input[type="file"]');
                        label.innerHTML = `<span class="filename">${fileName}</span><div class="remove-file" role="button" aria-label="Datei entfernen"></div>`;
                        if (fileInputElement) {
                            label.appendChild(fileInputElement);
                        }
                    }

                    // Add click handler to remove button
                    const removeBtn = label.find('.remove-file');
                    if (removeBtn) {
                        removeBtn.on('click', function(e) {
                            e.preventDefault();
                            e.stopPropagation();

                            // Clear the file input
                            fileInput.value = '';

                            // Update display
                            updateFileDisplay();
                        });
                    }
                } else {
                    inputFile.classList.remove('has-file');
                    // Restore original label content
                    if (labelContent) {
                        labelContent.innerHTML = originalLabelContent;
                    } else {
                        const fileInputElement = label.find('input[type="file"]');
                        label.innerHTML = originalLabelContent;
                        if (fileInputElement) {
                            label.appendChild(fileInputElement);
                        }
                    }
                }
            }

            // File input change event
            fileInput.on('change', function(e) {
                updateFileDisplay();
            });

            // Prevent label click when has file (to avoid accidentally opening file picker)
            label.on('click', function(e) {
                if (inputFile.classList.contains('has-file')) {
                    // If clicking on remove button, let it handle the click
                    if (e.target.classList.contains('remove-file')) {
                        return;
                    }
                    // Otherwise prevent the file picker from opening
                    e.preventDefault();
                }
            });

            // Drag & Drop functionality
            let dragCounter = 0;

            // Prevent default drag behaviors
            ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
                inputFile.addEventListener(eventName, preventDefaults, false);
                document.body.addEventListener(eventName, preventDefaults, false);
            });

            function preventDefaults(e) {
                e.preventDefault();
                e.stopPropagation();
            }

            // Add dragging class on dragenter/dragover
            ['dragenter', 'dragover'].forEach(eventName => {
                inputFile.addEventListener(eventName, function(e) {
                    if (eventName === 'dragenter') {
                        dragCounter++;
                    }
                    inputFile.classList.add('dragging');
                }, false);
            });

            // Remove dragging class on dragleave
            inputFile.addEventListener('dragleave', function(e) {
                dragCounter--;
                if (dragCounter === 0) {
                    inputFile.classList.remove('dragging');
                }
            }, false);

            // Handle drop
            inputFile.addEventListener('drop', function(e) {
                dragCounter = 0;
                inputFile.classList.remove('dragging');

                const dt = e.dataTransfer;
                const files = dt.files;

                if (files.length > 0) {
                    // Set the file to the file input
                    fileInput.files = files;

                    // Trigger change event to update display
                    const event = new Event('change', { bubbles: true });
                    fileInput.dispatchEvent(event);
                }
            }, false);

            // Check file state on page load (for validation errors)
            updateFileDisplay();
        });

        // click on add file button
        addFileButton.on('click', function(e) {
            e.preventDefault();
            const nextInputFile = multiFileUpload.find('.input-file:not(.active)');
            if (nextInputFile) {
                nextInputFile.classList.add('active');
            }
            // hide button if all inputs are active
            if (!multiFileUpload.find('.input-file:not(.active)')) {
                addFileButton.style.display = 'none';
            }
        });

        // Function to reset form
        function resetMultiFileUpload() {
            // Re-query the elements in case CF7 replaced the DOM
            const currentMultiFileUpload = document.querySelector('.multi-file-upload');
            if (currentMultiFileUpload && currentMultiFileUpload !== multiFileUpload) {
                // Re-query all elements
                const currentInputFiles = currentMultiFileUpload.querySelectorAll('.input-file');
                const currentAddFileButton = currentMultiFileUpload.querySelector('.button');

                currentInputFiles.forEach((inputFile, index) => {
                    const fileInput = inputFile.querySelector('input[type="file"]');
                    const label = inputFile.querySelector('label');
                    const labelContent = label ? label.querySelector('.label-content') : null;

                    // Clear the file input
                    if (fileInput) {
                        fileInput.value = '';
                    }

                    // Reset the label
                    inputFile.classList.remove('has-file');
                    if (labelContent) {
                        labelContent.innerHTML = '<span class="underline">Datei auswählen</span> oder hier ablegen';
                    }

                    // Hide all except the first file input
                    if (index === 0) {
                        inputFile.classList.add('active');
                    } else {
                        inputFile.classList.remove('active');
                    }
                });

                // Show the "add file" button again
                if (currentAddFileButton) {
                    currentAddFileButton.style.display = '';
                }
                return;
            }

            // Original reset logic (if DOM wasn't replaced)
            inputFiles.forEach((inputFile, index) => {
                const fileInput = inputFile.find('input[type="file"]');
                const label = inputFile.find('label');
                const labelContent = label.find('.label-content');

                // Clear the file input - force clear by creating new file list
                if (fileInput) {
                    try {
                        fileInput.value = '';
                        fileInput.type = 'text';
                        fileInput.type = 'file';
                    } catch (e) {
                        // Fallback for browsers that don't allow type change
                        fileInput.value = '';
                    }
                }

                // Always remove has-file class and reset label
                inputFile.classList.remove('has-file');
                const originalContent = originalLabels.get(inputFile);
                if (labelContent && originalContent) {
                    labelContent.innerHTML = originalContent;
                } else if (label && originalContent) {
                    // For labels without .label-content
                    const currentFileInput = label.find('input[type="file"]');
                    label.innerHTML = originalContent;
                    if (currentFileInput) {
                        label.appendChild(currentFileInput);
                    }
                }

                // Hide all except the first file input
                if (index === 0) {
                    inputFile.classList.add('active');
                } else {
                    inputFile.classList.remove('active');
                }
            });

            // Show the "add file" button again
            if (addFileButton) {
                addFileButton.style.display = '';
            }
        }

        // Re-check file states when Contact Form 7 reloads (after validation)
        const handleMailSent = function(event) {
            // Get the form ID or unit tag to identify the form
            const unitTag = event.detail.unitTag;
            const form = document.querySelector(`#${unitTag}`);

            // Check if this form contains this specific multi-file-upload element
            if (!form || !form.contains(multiFileUpload)) {
                return;
            }

            // Wait a tick for CF7 to reset the form
            setTimeout(() => {
                // Reset this specific multi-file-upload
                resetMultiFileUpload();
            }, 100);
        };

        const handleInvalid = function(event) {
            // Check if this event is for a form that contains our multi-file-upload
            const form = event.detail.containerElement;
            if (!form || !form.contains(multiFileUpload)) return;

            // Update file displays based on current state
            inputFiles.forEach((inputFile) => {
                const fileInput = inputFile.find('input[type="file"]');
                if (fileInput) {
                    // Trigger the updateFileDisplay function
                    const changeEvent = new Event('change', { bubbles: true });
                    fileInput.dispatchEvent(changeEvent);
                }
            });
        };

        document.addEventListener('wpcf7mailsent', handleMailSent);
        document.addEventListener('wpcf7invalid', handleInvalid);

        // Also listen for the wpcf7submit event
        document.addEventListener('wpcf7submit', function(event) {
            if (event.detail.status === 'mail_sent') {
                handleMailSent(event);
            }
        });

    });
});